var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.425 34.9018C13.1154 35.8876 13.3734 37.0142 13.9926 37.5775C14.2506 37.8592 14.6118 38 14.973 38C15.3342 38 15.747 37.8592 16.0566 37.5071L29.2147 21.7346C29.7823 21.1009 29.9371 20.1152 29.6791 19.1998C29.4211 18.3548 28.8019 17.7915 28.1311 17.7915H22.3518L26.325 5.11723C26.6346 4.13145 26.4282 3.00485 25.7574 2.44154C25.1382 1.80783 24.3126 1.87824 23.745 2.51196L10.5354 18.2844C10.0194 18.9181 9.86456 19.9039 10.1226 20.8193C10.329 21.6642 10.9482 22.2275 11.6706 22.2275H17.3982L13.425 34.9018ZM21.2188 10.5744L18.5814 18.9875H14.1727L21.2188 10.5744ZM21.1686 21.0315L18.5119 29.5061L25.5818 21.0315H21.1686Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.d26df02c33ca2a421457586076e7da21.svg";
export { ForwardRef as ReactComponent };